function farm_road_swcb(){
	var data = ajax_call(publicPath + "/napi/obs/hillslopecommunity/swcb/farmroad")
	var layer = L.geoJSON(data, {
		style: {
			color: "brown"
		}
	}).bindPopup('<div id="other_area" style="width: 200px !important;">資料連結中...</div>').on('click', onClick)
	function onClick(e) {
		var this_feature = e.layer.feature.properties,
			trigger_method
		isiOS ? ( (trigger_method = "mouseover") ) : ( (trigger_method = "click"));
		setTimeout(function(){
			$("#other_area").html(
				"<h5>" + this_feature.NO + "</h5>" +
				"<h6>長度：" + this_feature.LEN.toFixed(2) + "公尺</h6>"
			)
		}, 1000);
	}
	return layer;
}

function debris_flow_swcb(target = ''){
	raw_data["debris_basic"] ??= ajax_call("geojson/swcb/SWCB_Debris.geojson")
	var result = null,
		data = raw_data["debris_basic"],
		data_alert,
		data_village_memeber = ajax_call('geojson/village_chief_info.json'),
		result
	raw_data["土石流潛勢溪流"] ? ( (data_alert = raw_data["土石流潛勢溪流"]) ) : ( (data_alert = ajax_call(publicPath + "/napi/obs/debrisalert")));
	var data_alert_object = {};
	if (data_alert != null && data_alert.status != "fail") {
		if (data_alert.errorMessage == undefined) {
			data_alert.forEach(function(element){
				if (element.county == "新北市") {
					data_alert_object[element.debrisNo] = element;
				}
			})
		}
	} else {
		toast_open("水保署土石流警戒狀態API異常。")
	}
	var debris_flow_layer = L.geoJSON(data,{
		style: function(feature){
			try {
				feature.properties.village_info = data_village_memeber[feature.properties.Full.replace("新北市", "")]
			} catch (e) {}
			var object = {
				color: "#3ac569"
			};
			var raw_data_debris_no = feature.properties.Debrisno;
			if (data_alert_object[raw_data_debris_no] != undefined) {
				if (data_alert_object[raw_data_debris_no].alert_date_yellow != "") {
					object["color"] = "#FFBC42";
				} else if(data_alert_object[raw_data_debris_no].alert_date != ""){
					object["color"] = "#e85a71";
				} else {}
			}
			return object;
		},
		filter: (feature, layer) => {
			switch (target) {
				case '紅色':
					return data_alert_object[feature.properties.Debrisno].alert_date != ""
				case '黃色':
					return data_alert_object[feature.properties.Debrisno].alert_date_yellow != ""
				default:
					return feature
			}
		}
	}).bindPopup('<div id="other_area">資料連結中...</div>');
	debris_flow_layer.on('click', onClick);
	function onClick(e) {
		var this_marker = e.layer.feature.properties,
		 	trigger_method;
		isiOS ? ( (trigger_method = "mouseover") ) : ( (trigger_method = "click"));
		setTimeout(function(){
			$("#other_area").html(
				"<h5>" + this_marker.Full + this_marker.Debrisno + "</h5>" +
				"<h6>保全對象：" + this_marker.Full + "</h6>" +
				"<h6>類型：" + this_marker.Type + "</h6>" +
				"<h6>潛勢等級：" + this_marker.Potential + "</h6>" +
				"<h6>地標：" + this_marker.Mark + "</h6>" +
				"<h6>衝擊範圍：" + this_marker.R_area + "平方公尺</h6>" +
				"<h6>溪流長度：" + this_marker.Length + "公尺</h6>" +
				'<button type="button" class="btn btn-primary d-none" id="modal_trig">觀看農業局UAV資料</button>'
			);
			$("#modal_trig").on(trigger_method, function(){
				var html_string =
					"<h5>" + this_marker.Full + this_marker.Debrisno + "</h5>" +
					"<h6>UAV影像</h6>" +
					'<img src="../api/debris_pic/' + this_marker.Debrisno + '.jpg" class="w-100">' +
					'<h6 class="mt-10p">地形圖</h6>' +
					'<img src="../api/debris_pic/' + this_marker.Debrisno + '土石流潛勢溪流地形圖.jpg" class="w-100">';
				modal_open(html_string);
			})
		}, 1000);
	}
	result = [debris_flow_layer, data_alert];
	return result;
}

function debris_area_swcb(){
	raw_data["debris_area"] ??= ajax_call("geojson/swcb/SWCB_Debris_Area.geojson")
	var data = raw_data["debris_area"]
	var debris_area_layer = L.geoJSON(data,{
		style: {
			weight: 2,
			opacity: 1,
			color: '#964B00',
			fillColor: '#964B00',
			fillOpacity: 0.5
		}
	}).bindPopup('<div id="other_area">資料連結中...</div>');

	debris_area_layer.on('click', onClick);
	function onClick(e) {
		var this_marker = e.layer.feature.properties,
		 	trigger_method;
		isiOS ? ( (trigger_method = "mouseover") ) : ( (trigger_method = "click"));
		setTimeout(function(){
			$("#other_area").html(
				"<h5>" + this_marker.County + this_marker.Town + this_marker.Vill + this_marker.Debrisno + "</h5>" +
				"<h6>地址：" + this_marker.Address + "</h6>" +
				"<h6>影響戶數：" + this_marker.Total_Res + "戶</h6>" +
				"<h6>潛勢等級：" + this_marker.Risk + "</h6>"
			);
		}, 1000);
	}
	return debris_area_layer
}

function collapse_area_swcb(){
	raw_data["collapse_area"] ??= ajax_call("geojson/swcb/SWCB_Collapse_Area.geojson")
	var data = raw_data["collapse_area"]
	var collapse_area_layer = L.geoJSON(data,{
		style: {
			weight: 2,
			opacity: 1,
			color: '#ff0000',
			fillColor: '#ff0000',
			fillOpacity: 0.5
		}
	}).bindPopup('<div id="collapse_area_popup_info">資料連結中...</div>');

	collapse_area_layer.on('click', onClick);
	function onClick(e) {
		var this_marker = e.layer.feature.properties,
		 	trigger_method;
		isiOS ? ( (trigger_method = "mouseover") ) : ( (trigger_method = "click"));
		setTimeout(function(){
			$("#collapse_area_popup_info").html(
				"<h5>" + this_marker.County01 + this_marker.Town01 + this_marker.Vill01 + this_marker.Name + "</h5>" +
				"<h6>崩塌面積：" + (this_marker.P_area/100).toFixed(4) + "平方公里</h6>" +
				"<h6>影響戶數：" + this_marker.TRes_Class + "</h6>" +
				"<h6>潛勢等級：" + this_marker.Risk + "</h6>"
			);
		}, 1000);
	}
	return collapse_area_layer
}

function jiufen_sensor_layer(){
	var this_Icon = {
			iconUrl: '',
			iconAnchor:   [15, 32],
			iconSize:     [32, 32],
			popupAnchor:  [0, -20]
		},
		result
	var rain_data = ajax_call(publicPath + "/napi/obs/jiufen/rain"),
		underground_water_data = ajax_call(publicPath + "/napi/obs/jiufen/waterlevel"),
		geojson = new geoJsonTemplate(),
		underground_water_threshold = {
			"AOW-1": -4, "DOW-1": -5, "COW-3": -5, "COW-2": -5
		}
	if (underground_water_data != null) {
		underground_water_data.forEach(function(element){
			geojson.features.push({
				"type": "Feature",
				"geometry": {
					"type": "Point",
					"coordinates": [element.x, element.y]
				},
				"properties": {
					"stn_name": element.stn_name,
					"timestamp": element.timestamp,
					"w_level": element.w_level,
					"threshold": underground_water_threshold[element.stn_name]
				}
			})
		});
		var this_layer = L.geoJSON(geojson, {
			pointToLayer: function(feature, latlng) {
				(feature.properties.w_level < underground_water_threshold[feature.properties.stn_name]) ? ( (this_Icon["iconUrl"] = "marker_icon/underground_green.png") ) : ( (this_Icon["iconUrl"] = "marker_icon/underground_red.png"));
				return L.marker(latlng, {
		      		icon: new L.icon(this_Icon)
		    	}).bindPopup(
			    	'<div class="w-250">' +
			            '<h5 class="font-weight-bold">九份地滑-地下水位監測</h5>'+
			            '<h6>編號：' + feature.properties.stn_name + '</h6>' +
			            '<h6>時間：' + feature.properties.timestamp + '</h6>' +
			            '<h6>時雨量：' + rain_data[0].r_level + 'mm</h6>' +
			            '<h6>警戒水位：' + feature.properties.threshold + 'm</h6>' +
			            '<h6>水位高：' + feature.properties.w_level.toFixed(2) + 'm</h6>' +
		            '</div>'
	            );
			}
		});
	  	result = [this_layer, geojson];
	} else {
		result = false;
	}
	return result;
}

function liquefaction_cgs(){
	var result = null;
	var scriptUrl = 'geojson/cgs/liquefaction.geojson';
	function style(feature) {
		var color;
		switch(feature.properties.classify) {
		    case 0:
		        color = "#4CAF50"
		        break;
		    case 1:
		        color = "#FFEB3B"
		        break;
		    case 2:
		        color = "#FF0000"
		        break;
		}
    	return {
	        fillColor: color,
	        weight: 0,
	        opacity: 1,
	        color: 'white',
	        dashArray: '3',
	        fillOpacity: 0.5
	    };
	}
	var data = ajax_call(scriptUrl);
	var liquefaction_layer = L.geoJSON(data,{
		style: style,
		onEachFeature: function (feature, layer) {
			var text;
			switch(feature.properties.classify) {
			    case 0:
			        text = "低潛勢"
			        break;
			    case 1:
			        text = "中潛勢"
			        break;
			    case 2:
			        text = "高潛勢"
			        break;
	    	}
			layer.bindTooltip("土壤液化潛勢等級：" + text, {
				sticky: true,
				opacity: 1
			})
		}
	})
    result = liquefaction_layer;
	return result;
}

function earthquake_alert(){
	var data = ajax_call(publicPath + "/napi/obs/earthquakenewest"),
		geojson_center = {
			"type": "Feature",
			"geometry": {
				"type": "Point",
				"coordinates": [data.records.earthquake[0].earthquakeInfo.epiCenter.epiCenterLon.value, data.records.earthquake[0].earthquakeInfo.epiCenter.epiCenterLat.value]
			},
			"properties": {
				"depth": data.records.earthquake[0].earthquakeInfo.depth.value,
				"originTime": data.records.earthquake[0].earthquakeInfo.originTime,
				"magnitudeValue": data.records.earthquake[0].earthquakeInfo.magnitude.magnitudeValue
			}
		}
    var geojson_station = {
    	"type": "FeatureCollection",
    	"features": []
    };
    data.records.earthquake[0].intensity.shakingArea.forEach(function(each_region){
    	var boolean = Array.isArray(each_region.eqStation);
    	if (boolean == false) {
    		each_region.eqStation = [each_region.eqStation];
    	}
    	each_region.eqStation.forEach(function(each_station){
			try {
	    		var pga_list = [parseFloat(each_station.pga.ewComponent), parseFloat(each_station.pga.nsComponent), parseFloat(each_station.pga.vComponent)];
		    	geojson_station.features.push({
					"type": "Feature",
					"geometry": {
					    "type": "Point",
					    "coordinates": [parseFloat(each_station.stationLon.value), parseFloat(each_station.stationLat.value)]
					},
					"properties": {
						"distance": each_station.distance.value,
						"stationIntensity": String(each_station.stationIntensity.value),
						"stationName": each_station.stationName,
						"waveImageURI": each_station.waveImageURI,
						"peak_pga": Math.max(...pga_list)
					}
		    	});
			}
			catch(e){}
    	});
    });
	var earthquake_Icon = new L.icon({
		iconUrl: 'marker_icon/earthquake_center.png',
		iconAnchor:   [15, 32],
		iconSize:     [32, 32],
		popupAnchor:  [0, -20]
	})
    var earthquake_center_layer = L.geoJson(geojson_center, {
        pointToLayer: function(feature, latlng) {
			return L.marker(latlng, {
				icon: earthquake_Icon
			});
        }
    })
    var earthquake_station_layer = L.geoJson(geojson_station, {
        pointToLayer: function(feature, latlng) {
        	var text_color;
        	switch(feature.properties.stationIntensity){
        		case "1":
        			text_color = '<color_font class="earthquake-text-color-c1">' + feature.properties.stationIntensity + '</color_font>';
        			break;
        		case "2":
        			text_color = '<color_font class="earthquake-text-color-c2">' + feature.properties.stationIntensity + '</color_font>';
        			break;
        		case "3":
        			text_color = '<color_font class="earthquake-text-color-c3">' + feature.properties.stationIntensity + '</color_font>';
        			break;
        		case "4":
        			text_color = '<color_font class="earthquake-text-color-c4">' + feature.properties.stationIntensity + '</color_font>';
        			break;
        		case "5":
        			text_color = '<color_font class="earthquake-text-color-c5">' + feature.properties.stationIntensity + '</color_font>';
        			break;
        		case "6":
        			text_color = '<color_font class="earthquake-text-color-c6">' + feature.properties.stationIntensity + '</color_font>';
        			break;
        		case "7":
        			text_color = '<color_font class="earthquake-text-color-c7">' + feature.properties.stationIntensity + '</color_font>';
        			break;
        	}
            return L.marker(latlng, {
                icon: createLabelIcon("leaflet-textLabelclass_earthquake", text_color)
            });
        }
    });
	var earthquake_all_layer = L.layerGroup([earthquake_center_layer, earthquake_station_layer]),
		result
    result = [earthquake_all_layer, {layer: [geojson_center, geojson_station], info_data: data}];
    return result;
}

function getEarthquakeGridColor(intensity) {
	var color
	switch(true){
		case(intensity == 1):
			color = '#d9ffd9'
			break
		case(intensity == 2):
			color = '#00ff00'
			break
		case(intensity == 3):
			color = '#ff0'
			break
		case(intensity == 4):
			color = '#f60'
			break
		case(intensity == 5):
			color = '#f00'
			break
		case(intensity == 5.5):
			color = '#b31a1a'
			break
		case(intensity == 6):
			color = '#663333'
			break
		case(intensity == 6.5):
			color = '#801a80'
			break
		case(intensity == 7):
			color = '#9900cc'
			break
		default:
			color = '#fff'
	}
	return color
}

function getDamagedBuildingsColor(mag, val) {
	if (mag.includes('5強')) {
		switch (true) {
			case val < 8.2:
				return '#ddf3da'
			case val < 16.3:
				return '#aed4af'
			case val < 24.5:
				return '#7fb684'
			case val < 32.7:
				return '#509859'
			case val < 40.8:
				return '#21792e'
		}
	} else {
		switch (true) {
			case val < 37:
				return '#ffebeb'
			case val < 73:
				return '#eeb8b9'
			case val < 110:
				return '#dd8687'
			case val < 147:
				return '#cb5355'
			case val < 184:
				return '#ba2023'
		}
	}

}

function earthquake_alert_ncdr(event){
	function earthquakeGrid (e) {
		var this_marker = e.layer.feature.properties
		setTimeout(function(){
			$("#other_div").html(`
				<h5>地震初期評估震度網格</h5>
				<h6>震度：${this_marker.intensity}級</h6>
				<h6>PGA：${this_marker.pga}cm/sec<sup>2</sup></h6>
				<h6>PGV：${this_marker.pgv}cm/sec</h6>`
			)
		}, 500)
	}

	var gridLayer
	if (event.event_id == '2023年Terria模擬5強震度事件' || event.event_id == '2023年Terria模擬6弱震度事件') {
		// predicted damaged buildings legend
		let legend_html = event.event_id == '2023年Terria模擬5強震度事件'
			? '房屋損毀(棟)<br><img src="marker_icon/dmgbld_5strong.png" width="100%">'
			: '房屋損毀(棟)<br><img src="marker_icon/dmgbld_6weak.png" width="100%">'
		$('#ndcr_main_layer').html(legend_html)

		// predicted damaged buildings layer
		geojson = event.event_id == '2023年Terria模擬5強震度事件'
			? ajax_call("geojson/earthquake/teria5強建物.geojson")
	    	: ajax_call("geojson/earthquake/teria6弱建物.geojson")
		gridLayer = L.geoJSON(geojson, {
			style: function(feature){
				return {
					color: 'black',
					fillColor: getDamagedBuildingsColor(event.event_id, feature.properties.DmgBldMdr),
					weight: 1,
					fillOpacity: 1,
				}
			},
			onEachFeature: function (feature, layer) {
				let tooltipOptions = {
					direction: 'bottom',
					opacity: 1,
				};
				map.on('zoomend', function(){
					layer.closeTooltip()
					if (map.getZoom() >= 13) {
						layer.bindTooltip(`
							<div>
								<h6>行政區：${feature.properties.TownName}</h6>
								<h6>村里：${feature.properties.VillName}</h6>
								<h6>預估建物損毀中位數：${feature.properties.DmgBldMdr} 棟</h6>
							</div>
						`, tooltipOptions);
					} else {
						layer.unbindTooltip()
					}
				})


			}
		})
	} else {
		// earthquake magnitude legend
		$('#ndcr_main_layer').html('震度網格<br><img src="Legend/earthquake_pga_grid.jpg" width="100%">')
		// earthquake magnitude layer
		var data = ajax_call(publicPath + '/napi/simulate/earthquakencdr?event=' + event.event_id),
		geojson = preProcessingData.pssqlGeojson(data, 'geo'),
		gridLayer = L.geoJSON(geojson, {
			style: function(feature){
				return {
					fillColor: getEarthquakeGridColor(feature.properties.intensity),
					weight: 0,
					fillOpacity: 0.7,
					interactive: false
				}
			},
			onEachFeature: function (feature, layer) {
				layer.bindPopup('<div id="other_div" class="w-200"></div>');
			}
		}).on("click", earthquakeGrid)
	}

	// earthquake center layer
	var	earthquake_Icon = new L.icon({
		iconUrl: 'marker_icon/earthquake_center.png',
		iconAnchor:   [15, 32],
		iconSize:     [32, 32],
		popupAnchor:  [0, -20]
	})
	var	centerLayer = L.marker([event.lat, event.lon], {
		icon: earthquake_Icon,
		interactive: false
	})

	return L.layerGroup([gridLayer, centerLayer])
}

function earthquake_fault_line(){
	var result, data, thisLayer
	if (raw_data["山腳斷層"] == undefined) {
		data = ajax_call("geojson/ntc_fault_line.json")
	} else {
		data = raw_data["山腳斷層"]
	}
	thisLayer = L.geoJson(data, {
		style: function(){
			return { color: 'white', weight: 5, opacity: 1 }
		}
	}).bindPopup('<div class="w-200"><h5 class="font-weight-bold">山腳斷層</h5><h5>類型：第二類活動斷層</h5><h5>相關文件：<a href="http://www.geologycloud.tw/map/files/activefault/山腳斷層.pdf" target="_blank">連結</a></h5</div>')
	result = [thisLayer, data];
	return result;
}